export default "__VITE_ASSET__147a904d__"